import React from 'react'
import styled from 'styled-components'
import { ReactComponent as FileIcon } from "../../Assets/icons/fileIcon.svg"

const CallChatFileAttachmentItem = ({ file }) => {
  const returnMb = (size) => {
    if (!size) return '';

    let mb = (size / 1000000)
    let kb = (size / 1000)

    if (mb.toFixed(2) <= 1.00) {
        return `${kb.toFixed(2)} KB`
    } else {
        return `${mb.toFixed(2)} MB`
    }
  }

  return (
    <Container>
        <IconWrapper>
            <FileIcon />
        </IconWrapper>
        <InfoWrapper>
            <h1>{file.name}</h1>
            <p>{returnMb(file.size)}</p>
        </InfoWrapper>
    </Container>
  )
}

export default CallChatFileAttachmentItem

const Container = styled.div`
  display: flex;
  background: ${({ theme }) => theme.menu.background};
  padding: 10px 12px;
  border-radius: 10px;
  min-width: 100px;
  max-width: 280px;
  align-items: center;
  gap: 10px;
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  max-width: 32px;
  height: 32px;
  
  svg {
    color: ${({ theme }) => theme.menu.primaryTextColor};
    width: 28px;
    height: 28px;
  }
`

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  gap: 2px;
  
  h1 {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
    margin: 0;
  }
  
  p {
    color: ${({ theme }) => theme.menu.secondaryTextColor};
    font-size: 11px;
    font-weight: 400;
    line-height: 16px;
    margin: 0;
  }
`